// import node module libraries
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

// import translation
import { useTranslation } from 'react-i18next';

const Status = ({item, onSubmit, isLoadingButton}) => {
	const { t } = useTranslation(); // useTranslation-Hook
	const [status, setStatus] = useState(item.config_value.status);
	const [statusTitle, setStatusTitle] = useState(null);
	const [statusDescription, setStatusDescription] = useState(null);
	const [statusColor, setStatusColor] = useState(null);
	const [statusButton, setStatusButton] = useState(null);

	const getStatusTitle = (statusTitle) => {
		switch (statusTitle) {
			case 'paused':
				return 'Paused';
			case 'inactive':
				return 'Inactive';
			case 'ready':
				return 'Ready';
			case 'active':
				return 'Active';
			case 'completed':
				return 'Completed';
			case 'failed':
				return 'Failed';
			case 'configuration':
				return 'In configuration';
			case 'new':
				return 'New added';
			default:
				return 'Undefined';
		}
	};
	const getStatusColor = (status) => {
		switch (status) {
			case 'paused':
				return 'primary';
			case 'inactive':
				return 'secondary';
			case 'ready':
				return 'primary';
			case 'active':
				return 'success';
			case 'failed':
				return 'danger';
			case 'configuration':
				return 'warning';
			case 'new':
				return 'secondary';
			default:
				return 'secondary';
		}
	}
	const getStatusDescription = (status) => {
		switch (status) {
			case 'paused':
				return 'This Flow was paused because you exceeded the maximum number of runs. Please upgrade your plan to or wait for the next period to continue this Flow activity.';
			case 'inactive':
				return 'This Flow is inactive';
			case 'ready':
				return 'This Flow is ready to activate';
			case 'active':
				return 'This Flow is active';
			case 'failed':
				return 'This Flow has failed';
			case 'configuration':
				return 'Complete this Flow configuration';
			case 'new':
				return 'This Flow is new and needs to be configured';
			default:
				return 'This Flow status is undefined';
		}
	}
	const getStatusButton = (status) => {
		switch (status) {
			case 'paused':
				return 'pause-circle';
			case 'inactive':
				return 'pause-circle';
			case 'ready':
				return 'play';
			case 'active':
				return 'play';
			case 'failed':
				return 'alert-circle';
			case 'configuration':
				return 'alert-circle';
			case 'new':
				return 'alert-circle';
			default:
				return 'help-circle';
		}
	}

	useEffect(() => {
		setStatusTitle(getStatusTitle(status));
		setStatusDescription(getStatusDescription(status));
		setStatusColor(getStatusColor(status));
		setStatusButton(getStatusButton(status));
	}, [status]);

	// Update status when item changes
	useEffect(() => {
		setStatus(item.config_value.status);
	}, [item]);

	const handleStatusChange = (status) => {
		switch (status) {
			case 'paused':
				//setStatus('active');
				onSubmit('active');
				break;
			case 'inactive':
				//setStatus('active');
				onSubmit('active');
				break;
			case 'ready':
				//setStatus('active');
				onSubmit('active');
				break;
			case 'error':
				//setStatus('active');
				onSubmit('active');
				break;
			case 'active':
				//setStatus('paused');
				onSubmit('inactive');
				break;
			case 'failed':
				//setStatus('active');
				onSubmit('active');
				break;
			default:
				return status;
		}
	}
	
	// Animation state for "ready" bounce
	const [isBouncing, setIsBouncing] = useState(false);

	useEffect(() => {
		let bounceInterval;
		if (status === "ready" || status === "inactive") {
			bounceInterval = setInterval(() => {
				setIsBouncing(true);
				setTimeout(() => setIsBouncing(false), 300); // bounce duration
			}, 2500); // bounce every 2.5s
		}
		return () => clearInterval(bounceInterval);
	}, [status]);

	return (
		<Card 
			className={`mb-4 bg-${statusColor} border-primary ${(status === "ready" || status === "paused") && isBouncing ? "bounce" : ""}`} 
			style={{ transition: 'transform 0.2s', cursor: isLoadingButton ? 'not-allowed' : 'pointer', opacity: isLoadingButton ? 0.7 : 1 }} 
			onMouseEnter={(e) => { if (!isLoadingButton) e.currentTarget.style.transform = 'scale(1.01)'; }} 
			onMouseLeave={(e) => { if (!isLoadingButton) e.currentTarget.style.transform = 'scale(1)'; }}
			onClick={() => {
				if (!isLoadingButton) {
					handleStatusChange(status);
				}
			}}
		>
			<Card.Body>
				<Card.Title className="text-white" as="h4">
					{t('Flow Status')}
				</Card.Title>
				<div className="d-flex justify-content-between align-items-center mt-8">
					<div>
						<h1 className="display-4 text-white mb-1" style={{ userSelect: 'none' }}>{t(statusTitle)}</h1>
						<p className="mb-0 text-white" style={{ userSelect: 'none' }}>{t(statusDescription)}</p>
					</div>
					<div>
						<i className={`fe fe-${statusButton} fs-1 text-light-primary`} style={{ userSelect: 'none' }}></i>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};
export default Status;
